import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge, mergeConfigs } from 'tailwind-merge'

import { tailwindMergeConfig } from '@orus.eu/design-tokens/output/tailwind-merge.config'

/**
 * Code-owned spacing and shadow names live in `_shared-theme.css`, outside the
 * generated token config. Extend their theme groups so callers can override both
 * these tokens and the generated numeric/legacy scales.
 */
const PHARAOH_THEME_EXTENSIONS = {
  extend: {
    theme: {
      spacing: ['inline', 'stack', 'card', 'page', 'section'],
      shadow: ['05-subtle', '10-raised', '20-floating', '30-overlay'],
    },
  },
}

/**
 * `cn()` merges Tailwind class lists while resolving conflicts against the
 * Orus utility surface defined in `@orus.eu/design-tokens`. The merge config
 * is generated from the same tokens that emit `output/tailwind.css`, so a new
 * Orus token is automatically recognized after running
 * `turbo run generate --filter=@orus.eu/design-tokens`.
 */
const twMerge = extendTailwindMerge(tailwindMergeConfig, (config) => mergeConfigs(config, PHARAOH_THEME_EXTENSIONS))

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
